import React from 'react';
import DetailsTable from '../../../Table/DetailsTable';
import FeatureSummary from '../../../Util/FeatureSummary';

const AdminEmailsTable = ({ templates, loading }) => {
    const columns = [
        {
            name: 'Name',
            fieldName: 'name',
            minWidth: 300,
            maxWidth: 500,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'Template ID',
            fieldName: 'id',
            minWidth: 250,
            maxWidth: 400,
            isResizable: true,
        },
    ];

    const items = templates ?? [];

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
            />
            <FeatureSummary
                summary="This table displays all SendGrid email templates for the selected account. Use the Account dropdown to switch between Transactional, Drip, and Sandbox accounts. Use the Language filter to narrow results by language name in the template name."
                label="About Admin Emails"
            />
        </>
    );
};

export default AdminEmailsTable;
